/* eslint-disable react-hooks/exhaustive-deps */
import { apiSupplierGetLastV2 } from '@/api/mall';
import { getSettlementSourceList } from '@/views/h5/my-center/apps/purchaser/settlement/api';
import { getLastProject, saveLastProject, supplierSearch, tenderProjectSearch } from 'api/order';
import SearchFooter from 'comps/SearchFooter';
import { UserContext } from 'libs/contexts';
import { amI } from 'libs/user';
import { clearDataByValType } from 'libs/utils';
import { useContext, useEffect, useRef, useState } from 'react';
import { Field, Popup } from 'react-vant';
import { noop } from 'react-vant/lib/utils';
import { cls } from 'reactutils';
import CategoriesDrawer from './CategoriesDrawer';
import DateRange from './DateRange';
import SearchSelect from './SearchSelect';
import SearchTree from './SearchTree';

const PopupStyle = {
  width: 320,
  height: '100%',
};

export default function OrderDrawer({
  visible,
  onClose,
  conditionList,
  onChange = () => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  conditionTypeList: initConditionTypeList,
  actions = [],
  changeVal = noop,
  onSelect = noop,
  currentSelect,
  textValue,
  searchKey = 'keyword',
  onSearch = noop,
  value,
  searchDates,
  createUserNameKey,
  hideSupp = false,
  hideSearchSelect = false,
  orgParams,
  showSettlementSource = false,
}: any) {
  const userInfo = useContext(UserContext);
  const isPurchaser = amI(userInfo, 'purchaser');
  const filterInput = useRef();
  const [opened, setOpened] = useState(false);
  const [_currentSelect, _setCurrentSelect] = useState(actions[0]);
  const [_textValue, _setTextValue] = useState(value?.[searchKey]);

  const handleConfirm = () => {
    onClose();
  };

  const handleDrawerClose = () => {
    onClose();
  };

  const handleResetAll = () => {
    const condition = conditionList
      .map((v) => v.prop)
      .concat(searchDates.map((v) => v.range).flat());
    const newValue = {
      ...value,
      supplier: {},
      project: {},
      organization: {},
      thirdDataSource: {},
      [createUserNameKey]: '',
    };
    condition.forEach((v) => {
      newValue[v] = clearDataByValType(newValue[v]);
    });
    onChange(newValue);
  };

  const change = (val, prop) => {
    onChange(val, prop);
  };

  const changeSelect = (v, key) => {
    const newValue = { ...value, [key]: v };
    onChange(newValue);
  };

  const _onSelect = (action) => {
    _setCurrentSelect(action);
    onSelect?.(action);
  };

  const _changeVal = (e) => {
    _setTextValue(e);
    changeVal(e);
  };

  useEffect(() => {
    _setCurrentSelect(currentSelect);
    _setTextValue(textValue);
  }, [currentSelect, textValue]);

  return (
    <>
      <Popup
        visible={visible}
        onClose={handleDrawerClose}
        position="right"
        style={PopupStyle}
        overlayClass="condition-drawer-popup"
        transition="simple-right-transition"
      >
        <div className={cls('container')}>
          <div className={cls('conditionContainer')}>
            <div className="filter-input-wrap">
              {/* <div className="filter-input" ref={filterInput}>
                {actions.length > 1 && (
                  <>
                    <Popover
                      actions={actions}
                      onSelect={_onSelect}
                      onOpen={() => setOpened(true)}
                      onClosed={() => setOpened(false)}
                      teleport={filterInput.current}
                      reference={
                        <div className={cls('current-box', opened && 'open-pop')}>
                          {_currentSelect?.text}&nbsp;
                          <LeftArrow />
                        </div>
                      }
                    />
                    <div className="line" />
                  </>
                )}
                <Search
                  value={_textValue}
                  onChange={_changeVal}
                  placeholder={_currentSelect?.placeholder}
                  onSearch={onSearch}
                  rightIcon={
                    <span onClick={() => onSearch(_textValue)} className="search-icon">
                      <SearchIcon />
                    </span>
                  }
                  leftIcon={null}
                />
              </div> */}
            </div>
            <CategoriesDrawer conditionList={conditionList} onChange={change} value={value} />
            {isPurchaser && showSettlementSource && (
              <SearchSelect
                query={getSettlementSourceList}
                title="结算单来源"
                change={(v) => changeSelect(v, 'thirdDataSource')}
                value={value.thirdDataSource}
              />
            )}
            {isPurchaser && !hideSupp && (
              <SearchSelect
                query={supplierSearch}
                title="供应商"
                change={(e) => changeSelect(e, 'supplier')}
                value={value.supplier}
                showRecent={true}
                getRecent={apiSupplierGetLastV2}
              />
            )}
            {searchDates?.map((v, i) => (
              <DateRange key={i} change={change} title={v.title} value={value} range={v.range} />
            ))}

            {createUserNameKey && (
              <div className="itemWrap">
                <div className="itemTitle">创建人</div>
                <div className="text-panel">
                  <Field
                    placeholder="请输入创建人"
                    value={value[createUserNameKey]}
                    onChange={(val) =>
                      onChange({
                        ...value,
                        [createUserNameKey]: val.trim(),
                      })
                    }
                  />
                </div>
              </div>
            )}

            {isPurchaser && !hideSearchSelect && (
              <SearchSelect
                query={tenderProjectSearch}
                title="使用项目"
                change={(e) => changeSelect(e, 'project')}
                value={value.project}
                showRecent={true}
                getRecent={getLastProject}
                saveRecent={saveLastProject}
                name="projectName"
              />
            )}
            {isPurchaser && (
              <SearchTree
                title="所属组织"
                change={(e) => changeSelect(e, 'organization')}
                value={value.organization}
                name="organizationName"
                orgParams={orgParams}
              />
            )}
          </div>
          <SearchFooter
            onReset={() => {
              handleResetAll();
            }}
            onConfirm={handleConfirm}
          />
        </div>
      </Popup>
      <style jsx>{`
        .container,
        .moreContainer {
          display: flex;
          height: 100vh;
          flex-direction: column;
        }

        .itemWrap {
          padding: 10px 20px 17px 20px;
          border-bottom: 2px solid #f9f9f9;
        }

        .itemTitle {
          font-size: 15px;
          color: #262626;
          line-height: 13px;
          font-weight: bold;
          margin-bottom: 17px;
        }
        .text-panel :global(.rv-cell) {
          background: #f2f2f2;
        }
        .conditionContainer,
        .moreContentContainer {
          flex: 1 1 auto;
          overflow-y: auto;
        }
        .filter-input-wrap {
          padding: 10px 20px 17px 20px;
          border-bottom: 2px solid #f9f9f9;
        }
        .filter-input {
          flex: 1;
          padding-left: 16px;
          background: #f2f2f2;
          border-radius: 3px;
          height: 40px;
          font-size: 14px;
          color: #333333;
          line-height: 40px;
          display: flex;
        }
        .filter-input :global(.rv-popover__wrapper) {
          flex: 0 0 auto;
        }
        .filter-input-wrap :global(.rv-cell) {
          background-color: transparent;
          flex: 1;
        }
        .filter-input-wrap :global(.rv-field__right-icon) {
          display: flex;
        }
        .filter-input-wrap :global(.rv-popover__action) {
          width: 88px;
          padding: 0;
        }
        .filter-input-wrap :global(.rv-popover__content) {
          border-radius: 3px;
        }
        .filter-input-wrap :global(.rv-search) {
          background-color: #f2f2f2;
          padding-right: 3px;
        }
        .filter-input-wrap :global(.rv-search__content) {
          background-color: #f2f2f2;
          padding-left: 0;
        }
        .line {
          width: 1px;
          height: 16px;
          background: #d9d9d9;
          margin-right: 15px;
          transform: translate(14px, 12px);
        }
        .current-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .current-box :global(svg) {
          transform: translate(2px, 1px) rotate(-90deg);
        }
        .open-pop :global(svg) {
          transform: translate(2px, 1px) rotate(90deg);
        }
        .search-icon {
          transform: translateY(3px);
        }
        :global .more-popup {
          background: none;
        }

        :global .condition-drawer-popup {
          background: rgba(0, 0, 0, 0.6);
        }
      `}</style>
    </>
  );
}
